import React from "react";
import { Link, useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

export default function Master() {
  return;
  const { pathname } = useLocation();
  const hasAccess = usePrivateLink();

  /* =========================================================
     TOP MODULE MENUS
  ========================================================= */

  const topMenus = [
    {
      path: "/student/attendance/dashboard",
      label: "Student",
      icon: "ri-user-line",
    },
    {
      path: "/staff/attendance/dashboard",
      label: "Staff",
      icon: "ri-group-line",
    },
    {
      path: "/essl/devices/list",
      label: "ESSL Devices",
      icon: "ri-rfid-line",
    },
    {
      path: "/essl/devices/logs",
      label: "Device Logs",
      icon: "ri-history-line",
    },
    {
      path: "/holidays",
      label: "Holiday",
      icon: "ri-calendar-event-line",
    },
    {
      path: "/leave/request",
      label: "Leave Request",
      icon: "ri-calendar-schedule-line",
    },
  ];

  /* =========================================================
     DETECT CURRENT MODULE
  ========================================================= */

  let moduleName = "";

  if (pathname.includes("/student/")) {
    moduleName = "student";
  } else if (pathname.includes("/staff/")) {
    moduleName = "staff";
  } else if (pathname.includes("/transport/")) {
    moduleName = "transport";
  }

  const isAttendanceSection = !!moduleName;

  /* =========================================================
     ATTENDANCE MENUS
  ========================================================= */

  const attendanceMenus = [
    {
      path: `/${moduleName}/attendance/dashboard`,
      label: "Attendance Reports",
      icon: "ri-bar-chart-box-line",
    },

    ...(moduleName === "student"
      ? [
        {
          path: `/${moduleName}/attendance/manual`,
          label: "Mark Attendance",
          icon: "ri-user-follow-line",
        },
      ]
      : []),

    {
      path: `/${moduleName}/attendance/list`,
      label: "Message Status",
      icon: "ri-message-2-line",
    },

    {
      path: `/${moduleName}/attendance/list/monthly`,
      label: "Monthly Report",
      icon: "ri-calendar-line",
    },

    ...(moduleName === "student"
      ? [
        {
          path: `/${moduleName}/attendance/list/annual`,
          label: "Annual Report",
          icon: "ri-calendar-check-line",
        },
      ]
      : []),
  ];

  /* =========================================================
     ACTIVE MENU
  ========================================================= */

  const isTopMenuActive = (item) => {
    if (item.path.startsWith("/student")) {
      return pathname.startsWith("/student/");
    }

    if (item.path.startsWith("/staff")) {
      return pathname.startsWith("/staff/");
    }

    if (item.path.startsWith("/transport")) {
      return pathname.startsWith("/transport/");
    }

    if (item.path.startsWith("/holidays")) {
      return pathname.startsWith("/holidays");
    }

    if (item.path.startsWith("/leave/request")) {
      return pathname.startsWith("/leave/request");
    }

    if (item.path.startsWith("/essl/devices/list")) {
      return pathname === "/essl/devices/list";
    }

    if (item.path.startsWith("/essl/devices/logs")) {
      return pathname.startsWith("/essl/devices/logs");
    }

    return pathname === item.path;
  };

  const isAttendanceMenuActive = (item) => {
    return pathname === item.path;
  };

  /* =========================================================
     RENDER TOP MENU
  ========================================================= */

  const renderTopMenu = (item) => {
    if (!hasAccess(item.path)) {
      return null;
    }

    const active = isTopMenuActive(item);

    return (
      <Link
        key={item.path}
        to={item.path}
        className={`attendance-master-top-btn ${active ? "active" : ""
          }`}
      >
        <span className="attendance-master-top-icon">
          <i className={item.icon}></i>
        </span>

        <span>{item.label}</span>
      </Link>
    );
  };

  /* =========================================================
     RENDER ATTENDANCE MENU
  ========================================================= */

  const renderAttendanceMenu = (item) => {
    if (!hasAccess(item.path)) {
      return null;
    }

    const active = isAttendanceMenuActive(item);

    return (
      <Link
        key={item.path}
        to={item.path}
        className={`attendance-master-sub-btn ${active ? "active" : ""
          }`}
      >
        <i className={item.icon}></i>

        <span>{item.label}</span>
      </Link>
    );
  };

  /* =========================================================
     V2 DASHBOARD - ACCESS BASED PRIORITY
  ========================================================= */

  const v2DashboardRoutes = [
    {
      path: "/student/attendance/dashboard/v2",
      label: "Overview",
    },
    {
      path: "/attendance/mark",
      label: "Mark Attendance",
    },
    {
      path: "/attendance/reports/day-wise",
      label: "Day Wise",
    },
    {
      path: "/attendance/reports/monthly",
      label: "Monthly Reports",
    },
    {
      path: "/attendance/reports/annual",
      label: "Annual Reports",
    },
    {
      path: "/attendance/reports/low-attendance",
      label: "Low Attendance",
    },
    {
      path: "/attendance/reports/message-delivery",
      label: "Message Delivery",
    },
    {
      path: "/attendance/reports/admission-month-wise",
      label: "Admission Month Wise",
    },
    {
      path: "/student/attendance/followups",
      label: "Follow-ups",
    },
  ];

  const accessibleV2Route = v2DashboardRoutes.find((route) =>
    hasAccess(route.path)
  );

  const showV2Dashboard = Boolean(accessibleV2Route);

  const v2DashboardPath = accessibleV2Route?.path;

  const isV2Dashboard = pathname === v2DashboardPath;


  /* =========================================================
     UI
  ========================================================= */

  return (
    <>
      <div className="col-12 attendance-master-wrapper">

        {/* ==============================================
            TOP NAVIGATION
        ============================================== */}

        <div className="attendance-master-topbar">

          <div className="attendance-master-top-left">

            <div className="attendance-master-title">
              <div className="attendance-master-title-icon">
                <i className="ri-calendar-check-line"></i>
              </div>

              <div>
                <strong>Attendance</strong>
                <span>Management</span>
              </div>
            </div>

            <div className="attendance-master-top-menu">
              {topMenus.map(renderTopMenu)}
            </div>

          </div>

          {/* ==============================================
              V2 DASHBOARD RIGHT SIDE
          ============================================== */}

          {showV2Dashboard && (
            <div className="attendance-master-v2-area">

              <Link
                to={v2DashboardPath}
                className={`attendance-v2-dashboard-btn ${isV2Dashboard ? "active" : ""
                  }`}
              >
                <span className="v2-dashboard-icon">
                  <i className="ri-dashboard-3-line"></i>
                </span>

                <span className="v2-dashboard-copy">
                  <strong>V2 Dashboard</strong>
                  <small>{accessibleV2Route?.label || "New Analytics"}</small>
                </span>

                <span className="v2-new-badge">
                  NEW
                </span>

                <i className="ri-arrow-right-line v2-arrow"></i>
              </Link>

            </div>
          )}

        </div>

        {/* ==============================================
            ATTENDANCE SUB NAVIGATION
        ============================================== */}

        {isAttendanceSection && (
          <div className="attendance-master-subbar">

            <div className="attendance-master-sub-title">
              <i className="ri-function-line"></i>
              <span>
                {moduleName === "student"
                  ? "Student Attendance"
                  : moduleName === "staff"
                    ? "Staff Attendance"
                    : "Attendance"}
              </span>
            </div>

            <div className="attendance-master-sub-menu">
              {attendanceMenus.map(renderAttendanceMenu)}
            </div>

          </div>
        )}

      </div>

      {/* =====================================================
          STYLES
      ===================================================== */}

      <style>{`

        /* =====================================================
           MAIN WRAPPER
        ===================================================== */

        .attendance-master-wrapper {
          width: 100%;
          margin-bottom: 18px;
        }

        /* =====================================================
           TOP BAR
        ===================================================== */

        .attendance-master-topbar {
          width: 100%;
          min-height: 72px;

          display: flex;
          align-items: center;
          justify-content: space-between;

          gap: 18px;

          padding: 10px 12px;

          background: #ffffff;

          border: 1px solid #e6eaf0;
          border-radius: 14px;

          box-shadow:
            0 1px 2px rgba(16, 24, 40, 0.03),
            0 4px 14px rgba(16, 24, 40, 0.035);
        }

        .attendance-master-top-left {
          min-width: 0;

          display: flex;
          align-items: center;

          gap: 18px;

          flex: 1;
        }

        /* =====================================================
           TITLE
        ===================================================== */

        .attendance-master-title {
          display: flex;
          align-items: center;

          gap: 10px;

          flex-shrink: 0;

          padding-right: 18px;

          border-right: 1px solid #e9edf3;
        }

        .attendance-master-title-icon {
          width: 42px;
          height: 42px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 11px;

          background: #eef4ff;
          color: #2563eb;

          font-size: 21px;
        }

        .attendance-master-title > div:last-child {
          display: flex;
          flex-direction: column;

          line-height: 1.1;
        }

        .attendance-master-title strong {
          font-size: 14px;
          font-weight: 800;

          color: #1d2939;
        }

        .attendance-master-title span {
          margin-top: 3px;

          font-size: 10px;
          font-weight: 600;

          color: #98a2b3;

          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* =====================================================
           TOP MENU
        ===================================================== */

        .attendance-master-top-menu {
          min-width: 0;

          display: flex;
          align-items: center;

          gap: 5px;

          flex-wrap: wrap;
        }

        .attendance-master-top-btn {
          min-height: 40px;

          display: inline-flex;
          align-items: center;

          gap: 7px;

          padding: 7px 11px;

          border: 1px solid transparent;
          border-radius: 9px;

          color: #667085;

          text-decoration: none;

          font-size: 12px;
          font-weight: 700;

          white-space: nowrap;

          transition: all 0.18s ease;
        }

        .attendance-master-top-btn:hover {
          color: #344054;

          background: #f8fafc;

          border-color: #e4e7ec;
        }

        .attendance-master-top-icon {
          width: 27px;
          height: 27px;

          display: inline-flex;
          align-items: center;
          justify-content: center;

          border-radius: 7px;

          background: #f2f4f7;

          font-size: 15px;

          transition: all 0.18s ease;
        }

        .attendance-master-top-btn.active {
          color: #175cd3;

          background: #eff6ff;

          border-color: #dbeafe;
        }

        .attendance-master-top-btn.active
        .attendance-master-top-icon {
          color: #ffffff;
          background: #2563eb;
        }

        /* =====================================================
           V2 DASHBOARD
        ===================================================== */

        .attendance-master-v2-area {
          flex-shrink: 0;

          padding-left: 15px;

          border-left: 1px solid #e9edf3;
        }

        .attendance-v2-dashboard-btn {
          min-height: 48px;

          display: flex;
          align-items: center;

          gap: 9px;

          padding: 6px 10px 6px 7px;

          border: 1px solid #ddd6fe;
          border-radius: 11px;

          background:
            linear-gradient(
              135deg,
              #f5f3ff 0%,
              #eef2ff 100%
            );

          color: #5b21b6;

          text-decoration: none;

          transition:
            transform 0.18s ease,
            box-shadow 0.18s ease,
            border-color 0.18s ease;
        }

        .attendance-v2-dashboard-btn:hover {
          color: #4c1d95;

          border-color: #c4b5fd;

          transform: translateY(-1px);

          box-shadow:
            0 5px 14px rgba(109, 40, 217, 0.12);
        }

        .v2-dashboard-icon {
          width: 36px;
          height: 36px;

          display: flex;
          align-items: center;
          justify-content: center;

          flex-shrink: 0;

          border-radius: 9px;

          color: #ffffff;

          background:
            linear-gradient(
              135deg,
              #7c3aed,
              #4f46e5
            );

          font-size: 18px;

          box-shadow:
            0 3px 8px rgba(79, 70, 229, 0.22);
        }

        .v2-dashboard-copy {
          min-width: 84px;

          display: flex;
          flex-direction: column;

          line-height: 1.05;
        }

        .v2-dashboard-copy strong {
          font-size: 12px;
          font-weight: 800;

          color: #4c1d95;

          white-space: nowrap;
        }

        .v2-dashboard-copy small {
          margin-top: 4px;

          font-size: 9px;
          font-weight: 600;

          color: #8b5cf6;
        }

        .v2-new-badge {
          padding: 3px 5px;

          border-radius: 5px;

          background: #7c3aed;
          color: #ffffff;

          font-size: 7px;
          font-weight: 900;

          letter-spacing: 0.5px;
        }

        .v2-arrow {
          font-size: 15px;
          color: #7c3aed;
        }

        .attendance-v2-dashboard-btn.active {
          border-color: #7c3aed;

          background:
            linear-gradient(
              135deg,
              #ede9fe,
              #e0e7ff
            );

          box-shadow:
            0 4px 12px rgba(109, 40, 217, 0.12);
        }

        /* =====================================================
           SUB NAVIGATION
        ===================================================== */

        .attendance-master-subbar {
          min-height: 54px;

          display: flex;
          align-items: center;

          gap: 15px;

          margin-top: 8px;
          padding: 7px 10px;

          background: #ffffff;

          border: 1px solid #e6eaf0;
          border-radius: 12px;
        }

        .attendance-master-sub-title {
          display: flex;
          align-items: center;

          gap: 7px;

          flex-shrink: 0;

          padding: 0 13px 0 4px;

          border-right: 1px solid #e4e7ec;

          color: #98a2b3;

          font-size: 10px;
          font-weight: 800;

          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .attendance-master-sub-title i {
          font-size: 15px;

          color: #667085;
        }

        .attendance-master-sub-menu {
          display: flex;
          align-items: center;

          gap: 5px;

          flex-wrap: wrap;
        }

        .attendance-master-sub-btn {
          min-height: 36px;

          display: inline-flex;
          align-items: center;

          gap: 6px;

          padding: 6px 11px;

          border: 1px solid transparent;
          border-radius: 8px;

          color: #667085;

          text-decoration: none;

          font-size: 11px;
          font-weight: 700;

          white-space: nowrap;

          transition: all 0.18s ease;
        }

        .attendance-master-sub-btn i {
          font-size: 15px;
        }

        .attendance-master-sub-btn:hover {
          color: #344054;

          background: #f8fafc;

          border-color: #e4e7ec;
        }

        .attendance-master-sub-btn.active {
          color: #ffffff;

          background: #2563eb;

          border-color: #2563eb;

          box-shadow:
            0 2px 5px rgba(37, 99, 235, 0.18);
        }

        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 1199px) {

          .attendance-master-topbar {
            align-items: flex-start;
          }

          .attendance-master-top-left {
            flex-direction: column;
            align-items: flex-start;

            gap: 9px;
          }

          .attendance-master-title {
            border-right: 0;

            padding-right: 0;
          }

          .attendance-master-v2-area {
            align-self: center;
          }

        }

        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 767px) {

          .attendance-master-wrapper {
            margin-bottom: 12px;
          }

          .attendance-master-topbar {
            flex-direction: column;

            gap: 10px;

            padding: 10px;

            border-radius: 12px;
          }

          .attendance-master-top-left {
            width: 100%;
          }

          .attendance-master-title-icon {
            width: 38px;
            height: 38px;

            font-size: 19px;
          }

          .attendance-master-top-menu {
            width: 100%;

            display: grid;
            grid-template-columns:
              repeat(2, minmax(0, 1fr));

            gap: 6px;
          }

          .attendance-master-top-btn {
            width: 100%;

            justify-content: flex-start;

            padding: 7px 8px;

            font-size: 11px;
          }

          .attendance-master-v2-area {
            width: 100%;

            padding-left: 0;
            padding-top: 9px;

            border-left: 0;
            border-top: 1px solid #e9edf3;
          }

          .attendance-v2-dashboard-btn {
            width: 100%;

            justify-content: flex-start;
          }

          .v2-arrow {
            margin-left: auto;
          }

          .attendance-master-subbar {
            flex-direction: column;
            align-items: stretch;

            gap: 7px;

            padding: 8px;
          }

          .attendance-master-sub-title {
            border-right: 0;
            border-bottom: 1px solid #eaecf0;

            padding: 2px 3px 8px;
          }

          .attendance-master-sub-menu {
            display: grid;

            grid-template-columns:
              repeat(2, minmax(0, 1fr));

            gap: 6px;
          }

          .attendance-master-sub-btn {
            width: 100%;

            justify-content: flex-start;

            padding: 7px 8px;

            font-size: 10.5px;
          }

        }

        /* =====================================================
           SMALL MOBILE
        ===================================================== */

        @media (max-width: 420px) {

          .attendance-master-top-menu,
          .attendance-master-sub-menu {
            grid-template-columns: 1fr;
          }

        }

      `}</style>
    </>
  );
}